import * as React from 'react';
import LocaleContext from './context';
import defaultLocaleData from './en_US';
const useLocale = (componentName, defaultLocale) => {
    const fullLocale = React.useContext(LocaleContext);
    const getLocale = React.useMemo(() => {
        const locale = defaultLocale || defaultLocaleData[componentName];
        const localeFromContext = fullLocale?.[componentName] ?? {};
        return {
            ...(typeof locale === 'function' ? locale() : locale),
            ...(localeFromContext || {}),
        };
    }, [componentName, defaultLocale, fullLocale]);
    const getLocaleCode = React.useMemo(() => {
        const localeCode = fullLocale?.locale;
        // Had use LocaleProvide but didn't set locale
        if (fullLocale?.exist && !localeCode) {
            return defaultLocaleData.locale;
        }
        return localeCode;
    }, [fullLocale]);
    return [getLocale, getLocaleCode];
};
export default useLocale;
